<template>
  <section v-loading="listLoading" class="page-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.topicId" placeholder="帖子编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.result" clearable placeholder="鉴定结果" @change="list">
            <el-option label="待鉴定" value="0"></el-option>
            <el-option label="鉴定为真" value="1"></el-option>
            <el-option label="鉴定为假" value="2"></el-option>
            <el-option label="无法鉴定" value="3"></el-option>
            <el-option label="需要补图" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="datetimerange"
            value-format="timestamp"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="Begin time"
            end-placeholder="End time"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-section topics" :style="{ height: tableHeight }">
      <div v-for="item in results" :key="item.id" class="topic-item">
        <div class="topic-avatar">
          <avatar :user="item.topic.user" />
        </div>
        <div class="topic-main">
          <div class="topic-header">
            <a
              :href="('/user/' + item.topic.user.id) | siteUrl"
              target="_blank"
              class="topic-nickname"
              >{{ item.topic.user.nickname }}</a
            >

            <div class="topic-info">
              <span v-if="item.topic.status === 1" style="color: red; font-weight: bold"
                >已删除</span
              >
              <span v-if="item.topic.recommend" style="color: red; font-weight: bold">已推荐</span>
            </div>
            <div class="topic-info">
              <span
                v-if="item.appraiseResult !== 0"
                style="font-weight: bold"
                :style="{
                  color: item.appraiseResult === 1 ? '#fa5151' : '#51ba5d',
                }"
              >
                {{
                  item.appraiseResult === 1
                    ? "Legit"
                    : item.appraiseResult === 2
                    ? "Not Pass"
                    : item.appraiseResult === 3
                    ? "Can't legit-check"
                    : "Need to add more images"
                }}
              </span>
            </div>

            <div v-if="item.price" class="topic-info">
              <span v-if="item.payMethod === 'SCORE'" style="color: red; font-weight: bold"
                >SCORE: {{ item.price }}</span
              >
              <span v-else style="color: red; font-weight: bold"
                >{{ item.payMethod }}: PHP{{ item.price }}</span
              >
            </div>
          </div>

          <div class="topic-metadata">
            <span class="topic-metadata-item">ID: {{ item.topic.topicId }}</span>
            <span class="topic-metadata-item">Date：{{ item.topic.createTime | formatDate }}</span>
            <span class="node">{{ item.topic.node ? item.topic.node.name : "" }}</span>
            <span v-for="tag in item.topic.tags" :key="tag.tagId" class="topic-metadata-item tag"
              >#{{ tag.tagName }}</span
            >
            <span
              v-if="item.superLegitCheck"
              class="topic-metadata-item"
              style="font-weight: bold; color: red"
              >Super-Legit-Check</span
            >
          </div>

          <div class="topic-title">
            <a :href="('/topic/' + item.topic.topicId) | siteUrl" target="_blank">{{
              item.topic.title
            }}</a>
          </div>

          <div class="topic-summary">
            {{ item.topic.content }}
          </div>

          <ul
            v-if="item.topic.imageList && item.topic.imageList.length"
            v-viewer
            class="topic-image-list"
          >
            <li v-for="(image, index) in item.topic.imageList" :key="index">
              <div class="image-item">
                <img :src="image.preview" :data-src="image.url" />
              </div>
            </li>
          </ul>

          <div class="topic-actions">
            <a class="action-item btn" @click="openAppraiseDialog(item.id)">{{
              item.appraiseResult === 1 || item.appraiseResult === 2 ? "重新鉴定" : "鉴定"
            }}</a>
            <mute :user-id="item.topic.user.id">
              <a class="action-item btn">禁言该用户</a>
            </mute>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!-- 鉴定 -->
    <el-dialog title="鉴定" :visible.sync="appraiseFormVisible" width="350px">
      <el-form :model="appraiseForm" label-position="top" size="mini">
        <el-form-item label="鉴定结果：">
          <el-radio v-model="appraiseForm.result" :label="1">鉴定为真</el-radio>
          <el-radio v-model="appraiseForm.result" :label="2">鉴定为假</el-radio>
          <el-radio v-model="appraiseForm.result" :label="3">无法鉴别</el-radio>
          <el-radio v-model="appraiseForm.result" :label="4">需要补充</el-radio>
        </el-form-item>
        <el-form-item label="选择鉴定意见：">
          <el-select
            v-model="appraiseForm.opinionId"
            filterable
            placeholder="请选择鉴定意见"
            @change="changeOpinion"
          >
            <el-option
              v-for="opinion in opinionList"
              :key="opinion.id"
              :value="opinion.id"
              :label="opinion.title"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="鉴定意见：">
          <el-input v-model="appraiseForm.comment" type="textarea" :rows="3" placeholder="鉴定评价">
          </el-input>
        </el-form-item>
        <el-form-item label="示例图片：">
          <batch-image-upload v-model="appraiseForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appraiseFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAppraise">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import Avatar from "@/components/Avatar";
import BatchImageUpload from "@/components/BatchImageUpload";
import Mute from "@/views/pages/user/mute";

export default {
  name: "LegitCheck",
  components: { MyPagination, Avatar, BatchImageUpload, Mute },
  data() {
    return {
      tableHeight: "700px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},

      appraiseFormVisible: false,
      appraiseForm: {
        id: 0,
        comment: "",
        imageList: [],
        result: 0,
      },
      opinionList: [], // 鉴定意见库

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.list();
    this.loadOpinionList();
  },
  methods: {
    changeOpinion(opinionId) {
      if (this.opinionList && this.opinionList.length) {
        for (let i = 0; i < this.opinionList.length; i++) {
          const e = this.opinionList[i];
          if (e.id === opinionId) {
            this.appraiseForm.comment = this.appraiseForm.comment + e.content + "\n";
            this.appraiseForm.imageList.push(...e.imageList);
          }
        }
      }
    },
    async loadOpinionList() {
      this.opinionList = await this.axios.get("base:/api/admin/legit-check-opinion/list/all");
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/appraise/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "error ", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    /**
     * 打开鉴定弹窗
     * @param id 鉴定id
     */
    openAppraiseDialog(id) {
      // 初始化数据
      this.appraiseForm.id = id;
      this.appraiseForm.comment = "";
      this.appraiseForm.imageList = [];
      this.appraiseForm.result = 1;
      this.appraiseForm.opinionId = "";
      // 显示弹窗
      this.appraiseFormVisible = true;
    },
    /**
     * 提交鉴定结果
     */
    async submitAppraise() {
      try {
        await this.axios.form("base:/api/admin/appraise/appraise", {
          id: this.appraiseForm.id,
          comment: this.appraiseForm.comment,
          result: this.appraiseForm.result,
          imageList: JSON.stringify(this.appraiseForm.imageList || []),
        });
        this.$message({ message: "Submit success", type: "success" });
        this.appraiseFormVisible = false;
        await this.list();
      } catch (err) {
        this.$notify.error({ title: "error ", message: err.message || err });
      }
    },
    deleteSubmit(topicId) {
      const me = this;
      this.$confirm("是否确认删除该话题?", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(function () {
          me.axios
            .form("base:/api/admin/topic/delete", { id: topicId })
            .then(function () {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch(function (err) {
              me.$elnotify.error({
                title: "error ",
                message: err.message || err,
              });
            });
        })
        .catch(function () {
          me.$message({
            type: "info",
            message: "已Cancel删除",
          });
        });
    },
    async undeleteSubmit(topicId) {
      try {
        await this.axios.form("base:/api/admin/topic/undelete", { id: topicId });
        this.list();
        this.$message({ message: "Cancel删除成功", type: "success" });
      } catch (err) {
        this.$notify.error({ title: "error ", message: err.message || err });
      }
    },
    async recommend(id) {
      try {
        await this.axios.form("base:/api/admin/topic/recommend", {
          id,
        });
        this.$message({ message: "推荐成功", type: "success" });
        this.list();
      } catch (e) {
        this.$notify.error({ title: "error ", message: e.message });
      }
    },
    async cancelRecommend(id) {
      try {
        await this.axios.delete("base:/api/admin/topic/recommend", {
          params: {
            id,
          },
        });
        this.$message({ message: "Cancel推荐成功", type: "success" });
        this.list();
      } catch (e) {
        this.$notify.error({ title: "error ", message: e.message });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
